"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneSymbolInput = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Input_1 = require("../Input/Input");
exports.OneSymbolInput = (0, styled_components_1.default)(Input_1.Input).attrs({
    maxLength: 1,
}) `
  width: 28px;
  text-align: center;
`;
